import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

const DEFAULT_REACTIONS = ["👍", "❤️", "🔥", "🎉", "🤔"];
// Weekly-recap topics get a motivational set so accountability partners can react in a tap.
export const RECAP_REACTIONS = ["💪", "🔥", "👏", "🎯"];

export default function ReactionBar({ target, entity, onUpdate, currentUserId, emojis }) {
  // target: 'topic' | 'reply', entity: full doc with .id, .reactions, .reactions_names
  const set = emojis && emojis.length > 0 ? emojis : DEFAULT_REACTIONS;
  const reactions = entity?.reactions || {};
  const names = entity?.reactions_names || {};

  const react = async (emoji) => {
    try {
      const url = target === "topic"
        ? `/community/topics/${entity.id}/react`
        : `/community/topics/${entity.topic_id}/replies/${entity.id}/react`;
      const res = await api.post(url, { emoji });
      onUpdate?.(res.data);
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <div className="flex items-center gap-1 flex-wrap mt-2" data-testid={`reaction-bar-${target}-${entity.id}`}>
      {set.map((e) => {
        const users = reactions[e] || [];
        const count = users.length;
        const mine = currentUserId && users.includes(currentUserId);
        const nameList = names[e] || [];
        const tip = count > 0
          ? nameList.slice(0, 20).join(", ") + (nameList.length > 20 ? `, +${nameList.length - 20} more` : "")
          : "React " + e;
        return (
          <button
            key={e}
            type="button"
            onClick={() => react(e)}
            className={`inline-flex items-center gap-1 px-1.5 py-0.5 border font-mono-num text-[11px] transition-colors ${
              mine
                ? "border-[#0D9488] bg-[#0D9488]/10 text-[#0D9488]"
                : count > 0
                  ? "border-slate-300 bg-slate-50 text-slate-800 hover:border-zinc-500"
                  : "border-slate-200 bg-transparent text-slate-500 hover:text-white hover:border-zinc-600"
            }`}
            title={tip}
            data-testid={`react-${target}-${entity.id}-${e}`}
          >
            <span className="leading-none">{e}</span>
            {count > 0 && <span className="tabular-nums">{count}</span>}
          </button>
        );
      })}
    </div>
  );
}
